import { useCallback, useState } from "react";

/**
 * hook for Modal, Dropdown, etc.
 *
 * @returns
 */

export interface Toggleable {
  isOpen: boolean;
  toggle: () => void;
}

export default function useToggle(open = false): Toggleable {
  const [isOpen, setIsOpen] = useState(open)

  const toggle = useCallback(() => {
    setIsOpen(!isOpen)
  }, [isOpen])

  return { isOpen, toggle };
}
